import { render, staticRenderFns } from "./CustomerTvpRestrict.vue?vue&type=template&id=4788ab14&scoped=true&"
import script from "./CustomerTvpRestrict.vue?vue&type=script&lang=js&"
export * from "./CustomerTvpRestrict.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTvpRestrict.vue?vue&type=style&index=0&id=4788ab14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4788ab14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCard,VCheckbox})
